<template>
  <div id="puzzleapp" class="puzzleapp pe_wordsearch">

    <router-view />
<!-- 
    <ErrorModal 
      v-if="errorMessage"
    />
-->
    <Orientation />

  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex'
import ErrorModal from '@puzzleapps/shared/src/components/ui/ErrorModal'
import api from '@puzzleapps/shared/src/utils/api'
import Orientation from '@puzzleapps/shared/src/components/ui/Orientation'

export default {
  components: {
    ErrorModal,
    Orientation
  },

  created() {
    api.init(window.PE_CLIENTAPP_ID)
      .then(res => {
        this.setTitleHtml(res.titleHtml)
        this.setGameType(res.type)
        this.setGameName(res.name)
        this.setInitialized(true)
      })
      .catch(err => {
        console.error(err)
        this.setUnauthorised(true)
      })
  },

  mounted() {
    // prevent scrolling parent page within iframes
    document.onkeydown = e => {
      e = e || window.event
      if (e.keyCode >= 37 && e.keyCode <= 40) return false          
    }
  },

  methods: {
    ...mapActions({
      setTitleHtml: 'game/setTitleHtml',
      setGameType: 'game/setGameType',
      setGameName: 'game/setGameName',
      setInitialized: 'game/setInitialized',
      setUnauthorised: 'game/setUnAuthorised',
    }),
  },

  computed: {
    ...mapState({
      errorMessage: state => state.errors.message,
    }),
  }
}

</script> 

<style lang="scss">

@import '~@puzzleapps/shared/src/style/globalStyles';

</style>
